import { SortingHeader } from "./SortingHeader";

export function getHeadings() {
  return [
    {
      content: <SortingHeader index={0} label="recordsList.titleColumn" />,
    },
    {
      content: <SortingHeader index={1} label="recordsList.dateColumn" />,
    },
    {
      content: <SortingHeader index={2} label="recordsList.durationColumn" />,
    },
    {
      content: <SortingHeader index={3} label="recordsList.statusColumn" />,
    },
    {
      content: "",
    },
  ];
}
